import React, { useContext } from 'react';
import { BuilderElement } from '@builder.io/react';
import { useProductBandQuery } from '@/api/product/bands';
import { StaticProductSliderComponentProps } from '@/components/features/cms/blocks/StaticProductSlider/register';
import { ProductSlider as DSProductSlider } from '@/components/shared';
import { useIsHighPriorityBlock } from '@/contexts/HighPriorityBlocksProvider';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { useGetSettings } from '@/generated/settings';

interface StaticProductSliderProps extends StaticProductSliderComponentProps {
	readonly builderBlock: BuilderElement;
}

export const StaticProductSlider: React.FunctionComponent<StaticProductSliderProps> = ({
	title,
	subtitle,
	products,
	hideArrows,
	builderBlock,
}) => {
	const productArray = products?.map((p) => p.id) ?? [];

	const { segmentationId } = useContext(SegmentationContext);
	const { data: settings } = useGetSettings(segmentationId);
	const { data: results, isLoading } = useProductBandQuery(productArray, true, settings?.data?.searchSettings);

	const highPriority = useIsHighPriorityBlock(builderBlock.id ?? null);

	return (
		<DSProductSlider
			title={title}
			subtitle={subtitle}
			products={results}
			isLoading={isLoading}
			key={results?.length}
			lazyLoading={!highPriority}
			showArrows={hideArrows !== true}
		/>
	);
};
